import { OnboardingEmailResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type OnboardingEmailResponseInput = z.input<typeof OnboardingEmailResponseSchema>;
export type OnboardingEmailResponseOutput = z.output<typeof OnboardingEmailResponseSchema>;

export function serializeOnboardingEmailResponse(payload: OnboardingEmailResponseInput): OnboardingEmailResponseOutput {
  return OnboardingEmailResponseSchema.parse(payload);
}
